// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Grid, withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next'
import { CloseIcon, UploadIcon } from './icons';

const styles = theme => ({
    dropzone: {
        borderWidth: 1,
        borderStyle: 'dashed',
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3)
    },
    dropzone_form: {
        textAlign: 'center',
        cursor: 'pointer',
    },
    dropzone_previews: {
        margin: theme.spacing(2, 0),
    },
    image_preview: {
        height: theme.spacing(25),
        borderRadius: theme.spacing(2),
        width: '100%',
    },
    file_name: {
        fontSize: theme.spacing(3),
    },
    preview_imgs: {
        position: 'relative',
        width: '100%',
    },
    delete: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    icon_delete: {
        padding: theme.spacing(1),
        borderRadius: '50%',
        border: '1px solid ' + theme.palette.border.primary,
        backgroundColor: theme.palette.background.onCard,
        cursor: 'pointer',
    },
});

type FileUploaderProps = {
    onFileUpload?: PropTypes.func,
    showPreview?: boolean,
};

type FileUploaderState = {
    selectedFiles: Array<PropTypes.object>,
};

class FileUploader extends Component<FileUploaderProps, FileUploaderState> {
    static defaultProps = {
        showPreview: true,
    };

    constructor(props: FileUploaderProps) {
        super(props);
        this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);

        this.state = {
            selectedFiles: [],
        };
    }

    /**
     * Handled the accepted files and shows the preview
     */
    handleAcceptedFiles = (files: Array<PropTypes.object>) => {
        var allFiles = files;

        if (this.props.showPreview) {
            files.forEach((file, i) => {
                console.log("file===", file)
                Object.assign(file, {
                    preview: file ? URL.createObjectURL(file) : null,
                    formattedSize: this.formatBytes(file.size),
                    id: Date.now(),
                }
                );
                let blob = new Blob([file], { type: file.type });
                this.setState({
                    selectedFile: file,
                    previewIndex: 0,
                    downloadUrl: window.URL.createObjectURL(blob),
                });
            });
            //upload multi files
            allFiles = this.state.selectedFiles;
            allFiles.push(...files);
            this.setState({ selectedFiles: allFiles });
        }

        if (this.props.onFileUpload) this.props.onFileUpload(allFiles);
    };

    /**
     * Formats the size
     */
    formatBytes = (bytes: number, decimals: number = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    setPreviewIndex = (index) => {
        this.setState({
            previewIndex: index,
        })
    }

    //delete file
    onDeleteFile = (file, i) => {
        let files = this.state.selectedFiles;
        let filterFiles = files.filter((f, index) => index !== i);

        if (filterFiles && filterFiles.length > 0) {
            this.setState({
                selectedFile: filterFiles[0],
                selectedFiles: filterFiles,
                previewIndex: 0,
            });
        } else {
            this.setState({
                selectedFile: undefined,
                selectedFiles: [],
                previewIndex: 0,
            });
        }
        if (this.props.onFileUpload) this.props.onFileUpload(filterFiles);
    }

    render() {
        const { t, classes } = this.props;
        return (
            <React.Fragment>
                <Dropzone onDrop={acceptedFiles => this.handleAcceptedFiles(acceptedFiles)} {...this.props}>
                    {({ getRootProps, getInputProps }) => (
                        <div className={classes.dropzone}>
                            <div className={classes.dropzone_form} {...getRootProps()}>
                                <input {...getInputProps()} />
                                <UploadIcon />
                                <h3>{t('filesUploaderHeader')}</h3>
                                {/* <span className="text-muted font-13">
                                    {t('filesUploaderWarningInfoStart')}<strong>{t('not')}</strong> {t('filesUploaderWarningInfoEnd')}
                                </span> */}
                            </div>
                        </div>
                    )}
                </Dropzone>

                {this.props.showPreview && (
                    <Grid item xs={12} container spacing={1} alignItems='center' className={classes.dropzone_previews} id="file-previews">
                        {this.state.selectedFiles.map((f, i) => {
                            return (
                                <Grid item xs={12} sm={4} className="align-items-center" key={i}>
                                    {f.preview && (
                                        <Grid item className={classes.preview_imgs} onClick={() => this.setPreviewIndex(i)}>
                                            <img
                                                data-dz-thumbnail=""
                                                className={classes.image_preview}
                                                alt={f.name}
                                                src={f.preview}
                                            />
                                            <div className={classes.delete}>
                                                <div className={classes.icon_delete} onClick={() => this.onDeleteFile(f, i)}>
                                                    <CloseIcon style={{ color: 'grey', width: 20, height: 20 }} />
                                                </div>
                                            </div>
                                        </Grid>
                                    )}
                                    {!f.preview && (
                                        <Grid item xs={12}>
                                            <div className="avatar-sm">
                                                <span className="avatar-title bg-primary rounded">
                                                    {f.type.split('/')[0]}
                                                </span>
                                            </div>
                                        </Grid>
                                    )}
                                    {/* <Grid item xs={12}>
                                                <Link to="#" className={classes.file_name}>
                                                    {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                    <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Grid> */}
                                </Grid>
                            );
                        })}
                    </Grid>
                )}
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(withTranslation()(FileUploader));
